module.exports = __webpack_public_path__ + "static/media/swap.7102f766.svg";